import { StateCreator } from 'zustand';
import { SavedCalculation, ShipmentInput, ShipmentSummary } from '@freight-cbm/shared-types';

export interface HistorySlice {
  calculations: SavedCalculation[];
  searchQuery: string;
  saveCalculation: (name: string, shipment: ShipmentInput, summary: ShipmentSummary) => void;
  deleteCalculation: (id: string) => void;
  setSearchQuery: (query: string) => void;
  clearHistory: () => void;
}

export const createHistorySlice: StateCreator<HistorySlice> = (set) => ({
  calculations: [],
  searchQuery: '',
  saveCalculation: (name, shipment, summary) =>
    set((state) => {
      const newCalc: SavedCalculation = {
        id: `calc-${Date.now()}`,
        name,
        timestamp: new Date().toISOString(),
        shipment,
        summary,
      };
      const updated = [newCalc, ...state.calculations];
      return { calculations: updated.slice(0, 100) }; // max 100
    }),
  deleteCalculation: (id) =>
    set((state) => ({
      calculations: state.calculations.filter((c) => c.id !== id),
    })),
  setSearchQuery: (query) => set({ searchQuery: query }),
  clearHistory: () => set({ calculations: [], searchQuery: '' }),
});
